import { useTheme } from "@emotion/react";
import { LoadingButton } from "@mui/lab";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  Checkbox,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useMediaQuery,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../context/AuthContext";

const ConfirmPaidDialog = ({ orderId, open, onClose, onConfirm }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { authToken, ezorder } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleClose = () => {
    setErrorMessage("");
    onClose();
  };

  const handleConfirm = async () => {
    try {
      setLoading(true);
      const authHeader = {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      };
      const response = await ezorder.patch(
        `/admin/orders/${orderId}/payment-status`,
        {
          id: orderId,
          isPaid: true,
        },
        authHeader
      );

      if (response.status == 200 || response.status === 201) {
        setErrorMessage("");
        onConfirm();
      } else {
        if (
          response &&
          response.response &&
          response.response.data &&
          response.response.data.error
        ) {
          setErrorMessage(response.response.data.error);
        } else {
          setErrorMessage("Something went wrong");
        }
      }
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        if (error.response.data?.error) {
          setErrorMessage(error.response.data.error);
        } else {
          setErrorMessage("Internal server error");
        }
      } else {
        setErrorMessage("Internal server error");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      fullScreen={isSmallScreen}
      maxWidth="md"
      fullWidth={true}
      open={open}
      onClose={() => {
        if (!loading) handleClose();
      }}
    >
      <DialogTitle>Mark Order #{orderId} as Paid</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please confirm that there are no outstanding balances for this order.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          loading={loading}
          onClick={() => {
            if (!loading) handleClose();
          }}
        >
          Cancel
        </LoadingButton>
        <LoadingButton
          loading={loading}
          onClick={() => {
            setErrorMessage("");
            handleConfirm();
          }}
        >
          Mark as Paid
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmPaidDialog;
